import type { UserNotifyStore } from './const';
import { create } from 'zustand';
import { type INotify, UserNotify } from '@/services/user/const';

function getDefaultState() {
  return {
    initialized: false,
    isLoading: false,
    notifyList: [] as INotify[],
    notifies: {
      [UserNotify.NewVersionModal]: false,
      [UserNotify.TrafficPackage]: false,
      [UserNotify.GenerateFeedback]: false,
      [UserNotify.EditModeTutorial]: false,
      [UserNotify.UserCreditLog]: false,
    },
  };
}

/**
 * 通知名称到状态的映射
 */
function buildNotifiesMap(notifyList: INotify[]): Record<string, boolean> {
  return notifyList.reduce((map, notify) => {
    map[notify.name] = notify.needNotified;
    return map;
  }, {} as Record<string, boolean>);
}

const useStore = create<UserNotifyStore>((set) => ({
  ...getDefaultState(),

  setLoading: (isLoading) => {
    set({ isLoading });
  },

  setInitialized: (initialized) => {
    set({ initialized });
  },

  setNotifyList: (notifyList) => {
    set({
      notifyList,
      notifies: buildNotifiesMap(notifyList),
      initialized: true,
    });
  },

  updateNotifyState: (notifyName, needNotify) => {
    set((state) => ({
      notifies: { ...state.notifies, [notifyName]: needNotify },
      notifyList: state.notifyList.map((notify) =>
        notify.name === notifyName
          ? { ...notify, needNotified: needNotify }
          : notify,
      ),
    }));
  },

  updateNotifiesState: (data) => {
    set((state) => ({
      notifies: { ...state.notifies, ...data },
      notifyList: state.notifyList.map((notify) =>
        data[notify.name] !== undefined
          ? { ...notify, needNotified: data[notify.name] }
          : notify,
      ),
    }));
  },

  reset: () => {
    set(getDefaultState());
  },
}));

export const useUserNotifyStore = useStore;
